import _ from 'lodash'

export default ({ detail = false } = {}) => [
  {
    prop: 'so_id',
    label: '订单号',
    width: 200,
    renderCell(h, { row }) {
      if (row.order_id) {
        return <c-link-button to={{ name: 'orders.show', params: { id: row.order_id } }}>{ row.so_id }</c-link-button>
      }
    }
  },
  {
    prop: 'logistics_company',
    label: '快递公司'
  },
  {
    prop: 'lc_id',
    label: '快递公司代码'
  },
  {
    prop: 'latest_trace_info',
    label: '最新物流信息',
    renderCell(h, { row }) {
      if (detail) {
        return _.map(row.traces, r => (<p>{ r.time } { r.context }</p>));
      } else {
        return (
          <el-popover trigger="click">
            { _.map(row.traces, r => (<p>{ r.time } { r.context }</p>)) }
            <a href="#" slot="reference">{ row.latest_trace_info }</a>
          </el-popover>
        );
      }
    }
  },
  {
    prop: 'l_id',
    label: '快递单号'
  },
  {
    prop: 'send_date',
    label: '发货日期',
    renderCell: 'date',
    sort: 'order_by'
  }
];
